import script from "./TaskModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskModal.vue?vue&type=script&setup=true&lang=js"

import "./TaskModal.vue?vue&type=style&index=0&id=0c8bfe73&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c8bfe73"]])

export default __exports__